
import { defineComponent, onBeforeMount, ref } from 'vue';
import { TCell, TEmpty } from '@tencent/web-vbui';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { GetRecordList, GetLoanConfigList } from '../../core/network/NodeAPI';
import { IRecordListData } from '../../core/interface/IModel';
import { to } from '@tencent/vb-web-base-core';
import { i18n } from '@tencent/vb-web-base';
import { baseMixins } from '@common/mixins/baseMixins';
import dayjs from 'dayjs';
export default defineComponent({
  name: 'RecordList',
  components: {
    TCell,
    TEmpty,
  },
  setup() {
    const { getLang, getT } = i18n;
    const $t = getT();
    const lang = getLang();
    const isRequested = ref(false);
    const { setTitle, showModalError } = baseMixins();
    setTitle($t('领取记录'));
    const recordList = ref<IRecordListData['recordList']>([]);
    let activityNoList = ['loan20220509teslam101'];

    const getActivityNoList = async () => {
      const [data, err] = await to(GetLoanConfigList<{ content: {activityNo: string}[] }>('mgm_act_page'));
      if (err) {
        // showModalError(err.message, err.code);
        return;
      }
      if (data?.content?.length) {
        activityNoList = activityNoList.concat(...data.content.map(item => {
          try {
            const activityNos = JSON.parse(item.activityNo);
            return activityNos;
          } catch (err) {
            return [];
          }
        }));
      }
    };

    onBeforeMount(async () => {
      spin.show();
      await getActivityNoList();
      const [data, err] = await to(GetRecordList(activityNoList));
      if (err) {
        showModalError(err.message, err.code);
        spin.hide();
        isRequested.value = true;
        return;
      }
      spin.hide();
      isRequested.value = true;
      recordList.value = data.recordList.map((item) => {
        try {
          const extraInfo = JSON.parse(item.text);
          // eslint-disable-next-line no-param-reassign
          item.award_name = JSON.parse(item.award_name)[lang];
          // eslint-disable-next-line no-param-reassign
          item.award_info = `${extraInfo.currency} ${extraInfo.money}`;
        } catch (err) {}
        return item;
      });
    });
    return {
      isRequested,
      recordList,
      lang,
      dayjs,
    };
  },
});
